import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toggleModal } from '../../../reducers/modalReducer';

const UpgradeCards = ({ user, company, upgradePlan, setShowExpension }) => {

    const dispatch = useDispatch();
    const handleUpgrade = (card) => {
        if (upgradePlan) {
            setShowExpension(card['title']);
            return dispatch(toggleModal({ open: 'subscriptionPaymentConfirm' }));
        }
        dispatch(toggleModal({ open: 'whatYouGetModal' }));
    }

    // Don't show any cards if subscription is Pro
    if (company?.['subscription'] === 'Pro') {
        return null;
    }

    const allUpgradeCards = [
        {
            title: 'Lite',
            price: '£8.25',
            buttonText: 'Upgrade',
        },
        {
            title: 'Pro',
            price: '£83.25',
            buttonText: 'Upgrade',
        }
    ];

    // Filter cards based on subscription
    let upgradeCards = [];
    if (company?.['subscription'] === 'Free') {
        // Show both cards for Free subscription
        upgradeCards = allUpgradeCards;
    } else if (company?.['subscription'] === 'Lite') {
        // Show only PRO card for Lite subscription
        upgradeCards = allUpgradeCards.filter(card => card.title === 'Pro');
    } else {
        // Default: show both cards (for cases where subscription might be null or undefined)
        upgradeCards = allUpgradeCards;
    }
    // Don't render if no cards to show
    if (upgradeCards.length === 0) {
        return null;
    }

    return (
        <div className="df aic jcfe tac " style={{ marginTop: '5px' }}>
            {
                upgradeCards.map((card, index) => (
                    <div className={`shadow br20px p1rem ${(index + 1) === upgradeCards.length ? 'mr0rem' : 'mr1rem'}`} key={card.title}>
                        <div className='df aic jcc'>
                            <div className='df jcsb aifs fdc'>
                                <h3 className="fs1-25rem fw500 c59 w100 tal ttu">{card.title}</h3>
                                <p className="fs1-25rem fs1-5rem-sm fw500 c3">{card.price} <span className="fs14px c15 fw400">/month</span></p>
                            </div>
                            <button onClick={() => handleUpgrade(card)} className="bg4 bg3-hover fs1rem c1 td250 br30px px2rem py0-5rem cp tac mt0-5rem ml1rem fw600" >{card.buttonText}</button>
                        </div>
                    </div>
                ))
            }
        </div >
    )
}

export default UpgradeCards